// src/catalog/components/detail/CatalogEntryHero.jsx

import { formatLabel } from "../../utils/catalogDisplay";
import { ApplicationButton } from "../../../components/application";
import CatalogEntryStatusBadges from "./CatalogEntryStatusBadges";

export default function CatalogEntryHero({
  entry,
  title,
  titleId,
  description,
  localizedContentLang,
  metaItems = null,
  actionLabel,
  actionDisabled = false,
  actionControls = null,
  onPrimaryAction,
  secondaryActionContent = null
}) {
  if (!entry) return null;

  const hasMeaningfulMedia = Boolean(
    entry.bannerUrl || entry.thumbnailUrl
  );

  return (
    <section
      className={`catalog-detail__hero${hasMeaningfulMedia ? "" : " catalog-detail__hero--no-media"}`}
    >
      {hasMeaningfulMedia ? (
        <div className="catalog-detail__media">
          <img
            src={entry.bannerUrl || entry.thumbnailUrl}
            alt=""
          />
        </div>
      ) : null}

      <div className="catalog-detail__content">
        <CatalogEntryStatusBadges
          items={
            metaItems || [
              entry.primaryType && formatLabel(entry.primaryType),
              entry.deliveryMode && formatLabel(entry.deliveryMode),
              entry.lifecycleStatus &&
                formatLabel(entry.lifecycleStatus),
              entry.participationMode &&
                formatLabel(entry.participationMode)
            ].filter(Boolean)
          }
        />

        <div
          className="catalog-detail__localized-content"
          lang={localizedContentLang || undefined}
        >
          <h1 id={titleId}>{title}</h1>

          {description && (
            <p className="catalog-detail__description">
              {description}
            </p>
          )}

          {actionControls}
        </div>

        <div className="catalog-detail__actions-region">
          <div className="catalog-detail__actions">
            <ApplicationButton
              variant="primary"
              className="catalog-detail__primary-action-button"
              disabled={actionDisabled}
              onClick={onPrimaryAction}
            >
              {actionLabel}
            </ApplicationButton>
          </div>

          {secondaryActionContent ? (
            <div className="catalog-detail__secondary-context">
              {secondaryActionContent}
            </div>
          ) : null}
        </div>
      </div>
    </section>
  );
}
